import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import SearchBox from "../components/SearchBox";

export default function SearchPage() {
  const navigate = useNavigate();

  const handleProfileSelect = (profile) => {
    // go to route here
    navigate(`/profiles/${profile.username}`);
  };

  return (
    <div className="flex max-w-lg m-auto">
      <SearchBox onItemClick={handleProfileSelect} />
    </div>
  );
}
